import React, { createElement } from "react";
import { Tilt } from "react-tilt";
import { motion } from "framer-motion";

import { styles } from "./styles";
import { content } from "./content";
// import { services } from "../constants";
import { SectionWrapper } from "./hoc";
import { fadeIn, textVariant } from "./utils/motion";

const ServiceCard = ({ index, title, icon, tools }) => (
  <Tilt className="w-full sm:w-[320px] md:w-[340px] lg:w-[360px] px-2">
    <motion.div
      variants={fadeIn("right", "spring", index * 0.3, 0.75)}
      className="w-full green-pink-gradient p-[2px] rounded-[20px] shadow-card"
    >
      <div className="bg-[#06062a] rounded-[20px] py-6 px-6 h-[480px]
                      flex flex-col items-center">

        <img src={icon} className="w-20 h-20 object-contain bg-white rounded-xl" />

        <h3 className="text-white text-[18px] font-bold text-center mt-4">
          {title}
        </h3>

        <ul className="flex flex-wrap justify-center mt-6 gap-1
                       overflow-y-auto max-h-[260px]
                       scrollbar-thin scrollbar-thumb-purple-500">
          {tools.map((tool, j) => (
            <li
              key={j}
              className="border-2 px-2 py-1 green-pink-gradient text-xs rounded-xl whitespace-nowrap"
            >
              {tool}
            </li>
          ))}
        </ul>
      </div>
    </motion.div>
  </Tilt>
);


const EducationCard = ({ index, title, course, time, text, logo }) => (
  <Tilt className="w-full sm:w-[340px] md:w-[420px]">
    <motion.div
      variants={fadeIn("up", "spring", index * 0.3, 0.75)}
      className="w-full green-pink-gradient p-[2px] rounded-[22px] shadow-card"
    >
      <div
        className="bg-[#06062a] rounded-[22px]
                   px-8 py-8 h-[360px]
                   flex flex-col items-center
                   transition-transform duration-500
                   hover:scale-[1.02]"
      >
        {/* Logo */}
        <div className="w-24 h-24 rounded-full
                        bg-white flex items-center justify-center
                        shadow-md">
          <img
            src={logo}
            alt={title}
            className="w-16 h-16 object-contain"
          />
        </div>

        {/* Institution */}
        <h3 className="mt-6 text-white text-lg font-bold text-center">
          {title}
        </h3>

        {/* Course */}
        <p className="mt-2 text-gray-300 text-sm text-center">
          {course}
        </p>

        {/* Duration */}
        <span className="mt-4 px-4 py-1
                         text-xs font-semibold
                         rounded-full
                         green-pink-gradient">
          {time}
        </span>

        {/* Score / CGPA */}
        <div className="mt-6 px-6 py-3
                        rounded-xl
                        bg-[#0f0f3a]
                        border border-violet-500/40
                        text-center">
          <p className="text-sm text-gray-300">
            {text}
          </p>
        </div>
      </div>
    </motion.div>
  </Tilt>
);

const SectionContainer = ({ children }) => (
  <div className="w-full max-w-7xl mx-auto px-6 sm:px-10">
    {children}
  </div>
);


const About = () => {
  const { services, education } = content;

  return (
    <>
      {/* ================= OVERVIEW ================= */}
      <SectionContainer>
        <motion.div variants={textVariant()} className="">
          <p className={styles.sectionSubText}>Introduction</p>
          <h2 className={styles.sectionHeadText}>Overview.</h2>
        </motion.div>

        <motion.p
          variants={fadeIn("", "", 0.1, 1)}
          className="mt-6 text-secondary text-[17px] leading-[30px] max-w-3xl"
        >
          I am a software engineer with strong experience in building scalable
          backend systems, cloud-native microservices, and intelligent AI-driven
          solutions. Currently working at Oracle Financial Services Software, I
          develop and operate distributed services using Java, Spring Boot,
          Kubernetes, and CI/CD pipelines on cloud infrastructure.
          <br /><br />
          My work spans backend engineering, data-intelligent services, and
          Generative AI, including designing reliable APIs, migration services,
          and production-ready AI pipelines. I enjoy solving complex problems,
          optimizing systems for performance and reliability, and building
          end-to-end solutions that bridge backend systems with modern AI
          capabilities.
        </motion.p>
      </SectionContainer>

      {/* ================= EDUCATION ================= */}
      <SectionContainer>
        <motion.div variants={textVariant()} className="mt-10 text-center">
          <p className={styles.sectionSubHeadText}>Education</p>
        </motion.div>

        <div className="mt-12 flex flex-wrap justify-center gap-10">
          {education.map((item, index) => (
            <EducationCard key={item.title} index={index} {...item} />
          ))}
        </div>
      </SectionContainer>

      {/* ================= SKILLS ================= */}
      <SectionContainer>
  <motion.div variants={textVariant()} className="mt-10 text-center">
    <p className={styles.sectionSubHeadText}>Skills</p>
  </motion.div>

  <div className="mt-12 flex gap-10 overflow-x-auto no-scrollbar">
    {services.map((service, index) => (
      <ServiceCard key={service.title} index={index} {...service} />
    ))}
  </div>
</SectionContainer>

    </>
  );
};

export default SectionWrapper(About, "about");

